/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'category': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M74.969 30c-12.121 0-23.562 4.438-32.164 13.039-8.605 8.605-13.34 19.754-13.34 31.875.004 12.043 4.672 23.367 13.141 31.949C51.184 115.328 62.512 120 74.555 120c12.121 0 23.535-4.73 32.141-13.34 8.606-8.598 13.305-20.039 13.305-32.164V30H74.969zm21.73 30.055a7.854 7.854 0 0 1-7.855-7.855 7.854 7.854 0 0 1 7.855-7.856 7.854 7.854 0 0 1 7.856 7.855c.003 4.34-3.516 7.856-7.856 7.856z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
